import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from 'components/pure/utils/Dialog';
import SelectField from 'components/pure/utils/form/SelectField';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import generateSelectedItemsDescription from 'components/inbox/utils/generateSelectedItemsDescription';

const toOption = folder => ({value: folder.id, label: folder.name});

export default class MoveToFolderDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      folderId: this.props.currentFolderId,
    };
  }
  render() {
    const {areAllSelected, targets} = this.props;
    const {folderId} = this.state;
    const folders = this.props.folders.filter(folder => !folder.isOutbox());
    return (
      <Dialog
        className="move-to-folder-dialog"
        open={true}
        title="Move to Folder"
        closeButton={true}
        onRequestClose={this.props.onRequestClose}
        actions={[
          <Button
            variant="contained"
            color="primary"
            className="ev-button"
            disabled={!folderId || folderId === this.props.currentFolderId}
            onClick={() => this.props.onRequestMove(this.state.folderId)}>
            Save
          </Button>,
          <Button variant="outlined" className="ev-button" onClick={this.props.onRequestClose}>
            Cancel
          </Button>,
        ]}>
        <FieldContainer
          label={`Move ${generateSelectedItemsDescription({
            areAllSelected,
            targets,
          })} to Folder:`}>
          <SelectField
            tether={true}
            value={this.state.folderId || ''}
            options={folders.map(toOption)}
            onChange={folderId => this.setState({folderId})}
          />
        </FieldContainer>
      </Dialog>
    );
  }
}
